import ScrollToTop from '@components/scrolltop';
import { ReactNode, useEffect, useState } from 'react';

// ** Custom Hooks
import { useSkin } from '@hooks/useSkin';

// ** Third Party Components
import classnames from 'classnames';
import themeConfig from '@src/configs/themeConfig';
import { ArrowUp } from 'react-feather';
import { Button } from 'reactstrap';
import PrimaryFooter from './components/footer/PrimaryFooter';

type Props = {
  children: ReactNode;
};

const BlankLayout = ({ children }: Props) => {
  // ** States
  const [isMounted, setIsMounted] = useState(false);

  // ** Hooks
  const { skin } = useSkin();

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <div
      className={classnames('blank-page', {
        'dark-layout': skin === 'dark',
      })}
    >
      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-body">{children}</div>
        </div>
      </div>
      <footer>
        <PrimaryFooter />
      </footer>
      {themeConfig.layout.scrollTop === true ? (
        <div className="scroll-to-top">
          <ScrollToTop showOffset={300} classnames="scroll-top d-block">
            <Button className="btn-icon" color="primary">
              <ArrowUp size={14} />
            </Button>
          </ScrollToTop>
        </div>
      ) : null}
    </div>
  );
};

export default BlankLayout;
